let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iQ3Co")).then(() => parcelRequire('7AjxY'));